import { uniqBy } from "es-toolkit";

import { filterSuggestions } from "./utils/filterSuggestions";
import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";
import type { PlaceholderNodeModel } from "@/models/nodes/PlaceholderNodeModel";

function createPlaceholderSuggestion(node?: PlaceholderNodeModel): SingleSuggestion<"placeholder"> {
  const keywords = node?.linkId
    ? [
        node.linkId,
        // It would be better to use some kind of fuzzy matching here
        `place${node.linkId}`,
        `placeholder${node.linkId}`,
      ]
    : [];

  return {
    type: "single",
    item: {
      type: "placeholder",
      symbol: "□",
      displayName: "Placeholder",
      category: node?.linkId,
      keywords: normalizeSuggestionKeywords({
        keywords: ["placeholder", "empty", "fill", "slot", ...keywords],
      }),
      props: {
        linkId: node?.linkId,
      },
    },
    priority: 1,
  };
}

export const placeholderSuggestionsProvider: SuggestionProvider = {
  type: "placeholder",
  search: (str, doc) => {
    if (!str) {
      return [];
    }

    const nodes = uniqBy(
      doc.getNodesByType("placeholder").filter((node) => node.linkId),
      (node) => node.linkId,
    );

    const suggestions = nodes.reduce<SingleSuggestion<"placeholder">[]>((acc, node) => {
      if (node.linkId) {
        const suggestion = createPlaceholderSuggestion(node);
        return [...acc, suggestion];
      }

      return acc;
    }, []);

    return [filterSuggestions(str, [createPlaceholderSuggestion(), ...suggestions])];
  },
};
